import api from './client';
import type { LogsResponse, LogFilters } from '../types/logs';

/** Os 3 endpoints leem o MESMO conjunto de filtros — montar num lugar só é o que
 *  garante que "Limpar" apaga exatamente o que a listagem mostrou. */
const paramsDe = (filtros: LogFilters): URLSearchParams => {
  const params = new URLSearchParams();
  if (filtros.level) params.append('level', filtros.level);
  if (filtros.dias) params.append('dias', String(filtros.dias));
  if (filtros.correlationId) params.append('correlationId', filtros.correlationId);
  if (filtros.q) params.append('q', filtros.q);
  return params;
};

export const logsApi = {
  listar: async (filtros: LogFilters, page = 1, pageSize = 50): Promise<LogsResponse> => {
    const params = paramsDe(filtros);
    params.append('page', String(page));
    params.append('pageSize', String(pageSize));
    const r = await api.get<LogsResponse>(`/logs?${params.toString()}`);
    return r.data;
  },

  /** Baixa os logs que casam os filtros como um Blob JSON (o backend limita a 5000). */
  exportar: async (filtros: LogFilters): Promise<Blob> => {
    const r = await api.get(`/logs/export?${paramsDe(filtros).toString()}`, { responseType: 'blob' });
    return r.data as Blob;
  },

  /** Apaga os logs que casam os filtros (sem filtro = tudo). Devolve quantos saíram. */
  limpar: async (filtros: LogFilters): Promise<number> => {
    const r = await api.delete<{ success: boolean; data: { removidos: number } }>(`/logs?${paramsDe(filtros).toString()}`);
    return r.data.data.removidos;
  },
};
